import UserService from '../shared/user-service';
import { isAllowed } from '../shared/permissions/RestrictTo';
import {
  PERMISSION_ACCOUNT_DASHBOARD_ADMIN,
  PERMISSION_ACCOUNT_DASHBOARD_USER
} from '../shared/permissions/permissions';

export default {
  isAuthorized: () => {
    const userProfile = UserService.getUserProfile();
    if (userProfile) {
      const isAccountDashboardAdminWithVanpool =
        isAllowed([PERMISSION_ACCOUNT_DASHBOARD_ADMIN]) &&
        userProfile.vanpoolId;
      return (
        isAccountDashboardAdminWithVanpool ||
        !isAllowed([PERMISSION_ACCOUNT_DASHBOARD_USER])
      );
    }
    return false;
  }
};
